import React from 'react';
import { Wrapper, ValueWrapper } from './components'
import PropTypes from 'prop-types';

export const TextSwitchButton = ({ leftValue, rightValue, selectedValueId, onChange }) => {

  return (
    <Wrapper>
      <ValueWrapper
        selected={leftValue.id === selectedValueId}
        onClick={() => onChange(leftValue.id)}
      >
        {leftValue.value}
      </ValueWrapper>
      <ValueWrapper
        selected={rightValue.id === selectedValueId}
        onClick={() => onChange(rightValue.id)}
      >
        {rightValue.value}
      </ValueWrapper>
    </Wrapper>
  )
}

TextSwitchButton.propTypes = {
  leftValue: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  rightValue: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  selectedValueId: PropTypes.string,
  onChange: PropTypes.func,
};